"use client";

import Link from "next/link";
import { useCart } from "../data/CartContext";

const FREE_SHIPPING_THRESHOLD = 40;

export default function StickyCartBar() {
  const { cart } = useCart();
  const totalItems = cart.reduce((sum, item) => sum + item.qty, 0);
  const totalSpend = cart.reduce((sum, item) => sum + item.totalPrice * item.qty, 0);
  const remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - totalSpend);

  if (totalItems === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-[var(--bg-feature)] text-[var(--text-on-dark)] px-4 py-3 flex items-center justify-between shadow-[0_-2px_12px_color-mix(in_srgb,var(--ink)_15%,transparent)]">
      <div className="leading-tight">
        <p className="text-sm font-semibold">
          {totalItems} item{totalItems !== 1 ? "s" : ""} in cart
        </p>
        <p className="text-xs text-[var(--text-on-dark-muted)] mt-0.5">
          {remaining > 0
            ? `£${remaining.toFixed(2)} away from free shipping`
            : "Free UK shipping unlocked!"}
        </p>
      </div>
      <Link
        href="/shop/cart"
        className="bg-[var(--text-on-dark)] text-[var(--burgundy)] font-semibold text-sm px-4 py-2 rounded-full shrink-0"
      >
        View Cart →
      </Link>
    </div>
  );
}
